<div class="container">
    <div class="left-section">
      <mat-form-field appearance="fill" class="import-form-field">
        <mat-select class="custom-backdrop-class import-panel " panelClass="import-select" [(ngModel)]="proType"
          (ngModelChange)="setProType()">
          <mat-option *ngFor="let type of proTypes" [value]="type">{{type}}</mat-option>
        </mat-select>
      </mat-form-field>
  
      <mat-form-field appearance="fill" class="import-form-field">
        <mat-select class="custom-backdrop-class import-panel " panelClass="import-select" [(ngModel)]="proYear"
          (ngModelChange)="setProYear()">
          <mat-option *ngFor="let year of proYears" [value]="year">{{year}}</mat-option>
        </mat-select>
      </mat-form-field>
  
      <mat-radio-group class="import-quarters" aria-label="Select Quarter" [(ngModel)]="proQuarter"
        (ngModelChange)="setProQuarter()">
        <mat-radio-button *ngFor="let quarter of proQuarters" [value]="quarter">{{quarter}}</mat-radio-button>
      </mat-radio-group>
    </div>
  
    <div class="right-section">
      <button id="export-button" class="action-button" (click)="exportPro()">Export <app-upload-icon [stroke]="'white'"></app-upload-icon></button>
      <button id="create-data-set-button" class="action-button" (click)="createDataSet()">Create Data Set</button>
      <button id="filter-button" class="action-button" (click)="showFilterPanel()"><app-filter-panel-icon></app-filter-panel-icon></button>
    </div>
  </div>